import api from "Common/Client/Interceptor";
import { CareerLevelEnum } from "Common/Constants/Enums/Individual/CareerLevelEnum";
import { ProfessionTypeEnum } from "Common/Constants/Enums/Individual/ProfessionTypeEnum";

const BASE_URL = "/indv/SelfLearner/Profile";

export const fetchSelfLearnerProfile = async (token) => {
  try {
    const response = await api.get(BASE_URL, {
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    console.error("Error fetching self learner profile:", error);
    throw error;
  }
};


export const removeSelfLearnerProfilePicture = async (token) => {
  try {
    const response = await api.delete(`${BASE_URL}/Picture`, {
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    console.error("Error removing self learner profile picture:", error);
    throw error;
  }
};

export const updateSelfLearnerProfile = async (token, values, fileList) => {
  try {
    const formData = new FormData();

    // Add image file if present
    if (fileList?.length > 0 && fileList[0]?.originFileObj) {
      formData.append("ImageFile", fileList[0].originFileObj);
    }

    const queryParams = new URLSearchParams();

    queryParams.append("FirstName", values.firstName || "");
    queryParams.append("LastName", values.lastName || "");
    queryParams.append("PhoneNo", values.phoneNo || "");
    queryParams.append("Country", values.country || "");
    queryParams.append("State", values.state || "");
    queryParams.append("City", values.city || "");
    queryParams.append("EducationLevel", values.educationLevel ?? 0);
    queryParams.append("CareerLevel", values.careerLevel ?? 0);
    queryParams.append("Profession", values.profession ?? 0);

    // 🔴 CRITICAL FIX
    queryParams.append(
      "CareerLevelText",
      values.careerLevel === CareerLevelEnum.Other
        ? values.careerLevelText?.trim() || ""
        : ""
    );

    queryParams.append(
      "ProfessionText",
      values.profession === ProfessionTypeEnum.Other
        ? values.professionText?.trim() || ""
        : ""
    );

    console.log("Updating profile with params:", Object.fromEntries(queryParams));

    const response = await api.put(
      `${BASE_URL}?${queryParams.toString()}`,
      formData,
      {
        headers: {
          accept: "*/*",
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error updating self learner profile:", error);
    throw error;
  }
};
